var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCasesInactive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8799A8",
    fillRule: "evenodd",
    d: "M4.5 14.08v4.313c0 .238.224.432.5.432h15c.276 0 .5-.194.5-.432v-8.59c0-.239-.224-.432-.5-.432h-7.5c-.3 0-.584-.135-.774-.368l-2.6-3.178H5c-.276 0-.5.193-.5.431v7.824zM20 20.825H5c-1.378 0-2.5-1.09-2.5-2.432V6.256c0-1.34 1.122-2.43 2.5-2.43h4.601c.299 0 .584.133.774.366l2.599 3.18H20c1.378 0 2.5 1.09 2.5 2.431v8.59c0 1.341-1.122 2.432-2.5 2.432z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCasesInactive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cases_inactive.09157efa.svg";
export { ForwardRef as ReactComponent };